import React, { useState, useEffect } from 'react';

const Contact = () => {
  const [settings, setSettings] = useState({
    email: 'bimbelstemakupang@gmail.com',
    phone: '+0821-1751-9556',
    address: 'Jl. Frans Seda No.21, Klp. Lima, Kec. Klp. Lima',
    location_url: '',
    whatsapp_link: 'https://wa.me/6282117519556?text=Halo,%20saya%20ingin%20bertanya%20tentang%20bimbel%20Kedinasan.',
    facebook_link: 'https://facebook.com/akun',
    instagram_link: 'https://www.instagram.com/p/DLXDUp6TiNz/?igsh=Y2JoanZ0ZXQyMDA2',
    tiktok_link: 'https://vt.tiktok.com/ZSBH3cCax/'
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    loading: false,
    error: '',
    success: ''
  });

  // Fetch settings from API
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch('https://app.bimbelstemakupang.com/api/settings');
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setSettings({
              email: data.email || 'bimbelstemakupang@gmail.com',
              phone: data.phone || '+0821-1751-9556',
              address: data.address || 'Jl. Frans Seda No.21, Klp. Lima, Kec. Klp. Lima',
              location_url: data.location_url || '',
              whatsapp_link: data.whatsapp_link || 'https://wa.me/6282117519556?text=Halo,%20saya%20ingin%20bertanya%20tentang%20bimbel%20Kedinasan.',
              facebook_link: data.facebook_link || 'https://facebook.com/akun',
              instagram_link: data.instagram_link || 'https://www.instagram.com/p/DLXDUp6TiNz/?igsh=Y2JoanZ0ZXQyMDA2',
              tiktok_link: data.tiktok_link || 'https://vt.tiktok.com/ZSBH3cCax/'
            });
          }
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchSettings();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, error: '', success: '' });

    try {
      const response = await fetch('https://app.bimbelstemakupang.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setFormStatus({
          loading: false,
          error: '',
          success: 'Your message has been sent successfully! Thank you!'
        });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setFormStatus({
          loading: false,
          error: result.message || 'Failed to send message. Please try again.',
          success: ''
        });
      }
    } catch (error) {
      setFormStatus({
        loading: false,
        error: 'Network error. Please check your connection and try again.',
        success: ''
      });
    }
  };

  const socialLinkStyle = (bgColor) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '45px',
    height: '45px',
    backgroundColor: bgColor,
    color: 'white',
    borderRadius: '50%',
    marginRight: '12px',
    textDecoration: 'none',
    fontSize: '18px',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  });

  const handleSocialHover = (e, isEnter) => {
    if (isEnter) {
      e.target.style.transform = 'translateY(-3px) scale(1.05)';
      e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
    } else {
      e.target.style.transform = 'translateY(0) scale(1)';
      e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container section-title">
        <h2>Kontak</h2>
        <div>
          <span>BIMBEL STEMA</span> <span className="description-title">KUPANG</span>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="contact-info">
              <div className="contact-card">
                <h3>Kontak Kami</h3>
                <p>Untuk info lebih lanjut dapat menghubungi kami di bawah ini </p>
                
                <div className="contact-details">
                  <div className="contact-item">
                    <i className="bi bi-envelope"></i>
                    <div>
                      <h4>Email:</h4>
                      <p>
                        <a href={`mailto:${settings.email}`} style={{color: 'inherit', textDecoration: 'none'}}>
                          {settings.email}
                        </a>
                      </p>
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <i className="bi bi-telephone"></i>
                    <div>
                      <h4>Phone:</h4>
                      <p>
                        <a href={`tel:${settings.phone.replace(/[^+\d]/g, '')}`} style={{color: 'inherit', textDecoration: 'none'}}>
                          {settings.phone}
                        </a>
                      </p>
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <i className="bi bi-geo-alt"></i>
                    <div>
                      <h4>Alamat:</h4>
                      <p>{settings.address}</p>
                      <p>Kota Kupang, Nusa Tenggara Tim. 85111</p>
                      {settings.location_url && (
                        <a 
                          href={settings.location_url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            color: '#4285f4',
                            textDecoration: 'none',
                            fontSize: '14px',
                            fontWeight: '500'
                          }}
                        >
                          📍 View on Maps
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="social-links" style={{marginTop: '30px'}}>
                  <h4 style={{marginBottom: '15px', fontSize: '18px'}}>Follow Us:</h4>
                  
                  {settings.whatsapp_link && (
                    <a 
                      href={settings.whatsapp_link}
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={socialLinkStyle('#25D366')}
                      onMouseEnter={(e) => handleSocialHover(e, true)}
                      onMouseLeave={(e) => handleSocialHover(e, false)}
                      title="WhatsApp"
                    >
                      <i className="bi bi-whatsapp"></i>
                    </a>
                  )}
                  
                  {settings.facebook_link && (
                    <a 
                      href={settings.facebook_link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={socialLinkStyle('#1877F2')}
                      onMouseEnter={(e) => handleSocialHover(e, true)}
                      onMouseLeave={(e) => handleSocialHover(e, false)}
                      title="Facebook"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                  )}
                  
                  {settings.instagram_link && (
                    <a 
                      href={settings.instagram_link}
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={socialLinkStyle('#E4405F')}
                      onMouseEnter={(e) => handleSocialHover(e, true)}
                      onMouseLeave={(e) => handleSocialHover(e, false)}
                      title="Instagram"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>
                  )}
                  
                  {settings.tiktok_link && (
                    <a 
                      href={settings.tiktok_link}
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={socialLinkStyle('#000000')}
                      onMouseEnter={(e) => handleSocialHover(e, true)}
                      onMouseLeave={(e) => handleSocialHover(e, false)}
                      title="TikTok"
                    >
                      <i className="bi bi-tiktok"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-7">
            <div className="contact-form-wrapper">
              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row">
                  <div className="col-md-6 form-group">
                    <label htmlFor="name">Nama Anda *</label>
                    <input 
                      type="text" 
                      name="name" 
                      className="form-control" 
                      id="name" 
                      placeholder="John Doe"
                      value={formData.name}
                      onChange={handleInputChange}
                      required 
                    />
                  </div>
                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <label htmlFor="email">Email Anda *</label>
                    <input 
                      type="email" 
                      className="form-control" 
                      name="email" 
                      id="email" 
                      placeholder="john@example.com"
                      value={formData.email}
                      onChange={handleInputChange}
                      required 
                    />
                  </div>
                </div>
                
                <div className="form-group mt-3">
                  <label htmlFor="subject">Judul *</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    name="subject" 
                    id="subject" 
                    placeholder="Inquiry about tutoring programs"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                
                <div className="form-group mt-3">
                  <label htmlFor="message">Pesan *</label>
                  <textarea 
                    className="form-control" 
                    name="message" 
                    rows="7" 
                    placeholder="Tell us about your educational goals and how we can help..."
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
                
                <div className="my-3">
                  {formStatus.loading && (
                    <div className="loading" style={{
                      color: '#007bff',
                      textAlign: 'center',
                      padding: '10px',
                      fontWeight: '500'
                    }}>
                      Sending message...
                    </div>
                  )}
                  
                  {formStatus.error && (
                    <div className="error-message" style={{
                      color: '#dc3545',
                      backgroundColor: '#f8d7da',
                      border: '1px solid #f5c6cb',
                      borderRadius: '4px',
                      padding: '12px',
                      textAlign: 'center',
                      fontWeight: '500'
                    }}>
                      {formStatus.error}
                    </div>
                  )}
                  
                  {formStatus.success && (
                    <div className="sent-message" style={{
                      color: '#155724',
                      backgroundColor: '#d4edda',
                      border: '1px solid #c3e6cb',
                      borderRadius: '4px',
                      padding: '12px',
                      textAlign: 'center',
                      fontWeight: '500'
                    }}>
                      {formStatus.success}
                    </div>
                  )}
                </div>
                
                <div className="text-center">
                  <button 
                    type="submit" 
                    disabled={formStatus.loading}
                    style={{
                      backgroundColor: formStatus.loading ? '#6c757d' : '#007bff',
                      border: 'none',
                      color: 'white',
                      padding: '12px 30px',
                      borderRadius: '25px',
                      fontWeight: '600',
                      fontSize: '16px',
                      cursor: formStatus.loading ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 15px rgba(0,123,255,0.3)'
                    }}
                    onMouseEnter={(e) => {
                      if (!formStatus.loading) {
                        e.target.style.backgroundColor = '#0056b3';
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(0,123,255,0.4)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!formStatus.loading) {
                        e.target.style.backgroundColor = '#007bff';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 15px rgba(0,123,255,0.3)';
                      }
                    }}
                  >
                    {formStatus.loading ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;